import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiClayFilterConfig } from '@/data/landingConfig/landingAiClayFilterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiClayFilter } from './schemaObject';

interface Props {}
const AiClayFilter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiClayFilter} />
			<LandingTemplate
				data={landingAiClayFilterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiClayFilter;
